import store from "@/store";
import router from "@/router";

export default {
    addUnauthorizedInterceptor(axios) {
        axios.interceptors.response.use(response => response, error => {
            if (error.response?.status === 401) {
                store.commit("auth/setAuthorized", false);
                return store.dispatch("auth/refreshToken")
                    .then(_ => {
                        error.config.baseURL = undefined;
                        return axios.request(error.config);
                    })
                    .catch(err => {
                        if (err.response?.status === 401) {
                            return router.push('/login')
                                .then(() => {
                                    return Promise.reject(err);
                                });
                        }
                    });
            }
            return Promise.reject(error);
        });
    }
}